<template>
  <div>
    <!-- Filtro de busqueda de solicitudes -->
    <HistoricalFilter
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
    />

    <!-- Tabla de datos de solicitudes -->
    <HistoricalTable :dataSource="historicalData" />

    <div class="p-4 flex justify-end">
      <a-pagination
        v-model="page"
        :page-size="pageSize"
        :page-size-options="pageSizeOptions"
        :total="count"
        show-size-changer
        size="large"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import HistoricalFilter from "../partials/HistoricalFilter.vue";
import HistoricalTable from "../partials/HistoricalTable.vue";
import consumeService from "@/feature/historical/data/services/historical_impl";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "../../../../core/utils/constants";

export default {
  components: { HistoricalFilter, HistoricalTable },
  data() {
    return {
      count: 0,
      loading: false,
      form: {},
      historicalData: [],
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      count: 0,
      searching: false,
    };
  },
  methods: {
    async setFilterForm(form, pagination) {
      this.form = form;
      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };
      try {
        const { data } = await consumeService.getHistoricalConsum(
          pagination,
          this.form
        );
         
        this.setDeafultEmited(data);
      } catch (error) {
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return "";
      // Reemplaza la T por espacio y elimina la parte de milisegundos si existe
      return dateString.replace("T", " ").split(".")[0];
    },
    setDeafultEmited(data) {
      if (data && data.results && data.results.length > 0) {
        this.count = data.count;
        // Formatea el campo creation_date antes de asignar los datos
        this.historicalData = data.results.map((item) => ({
          ...item,
          creation_date: this.formatDateTime(item.creation_date),
        }));
      } else {
        this.count = 0;
        this.historicalData = [];
      }
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
  },
};
</script>

<style></style>
